module.exports = __webpack_public_path__ + "e80eee20dbf36fd2d60a44ea59fd43.png";